import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/arrow back small.svg` */
export const ArrowBackSmallIcon = createTripletGlyphIcon('ArrowBackSmallIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8236 3.59771C11.059 3.40618 11.4052 3.44163 11.597 3.67681C11.7889 3.91229 11.7534 4.25935 11.5179 4.45122L7.00034 8.13091L11.5023 11.5372C11.7445 11.7204 11.7929 12.0654 11.6097 12.3077C11.4265 12.5499 11.0814 12.5973 10.8392 12.4141L5.85288 8.64165C5.53118 8.39825 5.52257 7.91796 5.8353 7.66314L10.8236 3.59771Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => null,
  l: () => null,
});
